export function Authenticated({next, store, to}) {
  if (!store.getters['auth/loggedIn']) {
    return next({
      name: 'auth.signin',
    });
  }
  return next({next, store, to});
}

export function Guest({next, store, to}) {
  if (store.getters['auth/loggedIn']) {
    return next({
      name: 'cpanel'
    })
  }

  return next({next, store, to});
}

export function Permission({next, store, to}) {

  // let permission = to.meta.permission;
  if (!((store && store.state.session.session) && store.state.auth.profile)) {
    return next({
      name: 'cpanel.dashboard'
    })
  }

  return next({next, store, to});
}

export function middlewarePipeline(router, store) {

  function nextFactory(context, middleware, index) {



    const subsequentMiddleware = middleware[index]
    if (!subsequentMiddleware) return context.next

    return (...parameters) => {
      context.next(...parameters)
      const nextMiddleware = nextFactory(context, middleware, index + 1)
      subsequentMiddleware({...context, next: nextMiddleware})
    }
  }

  router.beforeEach(async (to, from, next) => {
    if (store.getters['auth/loggedIn'] && !store.getters['auth/profile']) {
      store.dispatch('auth/GET_PROFILE').then(() => {

      }).catch(() => {
        store.dispatch('auth/REFRESH_TOKEN')
      });
      store.dispatch('session/CURRENT').then(() => {

      }).catch(() => {
        // alert('Не удалось обновить токен, возможно не вы заходили долгое время. Авторизуйтесь еще раз!')
        store.dispatch('auth/LOGOUT')
        // router.push({name: "auth.signin"})
        location.reload()
      });
    }

    store.dispatch('loader/START')

    // if (window.innerWidth <= 500) store.commit('menu/SET_OPENED', 0)
    document.title = to.meta.title

    let routeMiddleware = to.meta.middleware
    if (!routeMiddleware && to.matched.length > 0 && to.matched[0].meta) {
      routeMiddleware = to.matched[0].meta.middleware
    }

    if (routeMiddleware) {
      const middleware = Array.isArray(routeMiddleware)
          ? routeMiddleware
          : [routeMiddleware]
      const context = {
        from,
        next,
        router,
        to,
      };
      const nextMiddleware = nextFactory(context, middleware, 1)
      return middleware[0]({...context, store, next: nextMiddleware, to: to})
    }

    return next()
  })

  router.afterEach(() => {
    store.dispatch('loader/STOP')

  })
}
